export default __webpack_public_path__ + "static/TonyShyrymbek-89402d1e460ca8f3fb6cffc1eeae74dc.png";